import { render, staticRenderFns } from "./ContactButton.vue?vue&type=template&id=3bcff218&scoped=true&"
import script from "./ContactButton.vue?vue&type=script&lang=js&"
export * from "./ContactButton.vue?vue&type=script&lang=js&"
import style0 from "./ContactButton.vue?vue&type=style&index=0&id=3bcff218&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcff218",
  null
  
)

export default component.exports